/**
 * Periyodik üretim modülü sabitleri.
 *
 * Admin'in otomatik, tekrarlayan soru üretim tarifeleri (CRUD). Her tarife bir DRAFT
 * köken üretim grubunu (şablon) referanslar; periyot tetiklendiğinde şablonu kopyalayıp
 * yeni bir üretim grubu üretir.
 */

export const periodicGenerationEndpoints = {
  // `status` ALL ise durum filtresi eklenmez; ACTIVE/PASSIVE → is_active true/false.
  list: (page: number, query: string, status?: string) => {
    const filters = [`name:${encodeURIComponent(query)}`]
    if (status === 'ACTIVE') filters.push('is_active:true')
    if (status === 'PASSIVE') filters.push('is_active:false')
    return `/periodic-generations?page=${page}&filters=${filters.join(',')}` // GET
  },
  availableDrafts: (includeId?: string) =>
    `/periodic-generations/available-drafts${
      includeId ? `?include_id=${includeId}` : ''
    }`, // GET
  create: '/periodic-generations', // POST
  detail: (id: string) => `/periodic-generations/${id}`, // GET
  update: (id: string) => `/periodic-generations/${id}`, // PATCH
  activate: (id: string) => `/periodic-generations/${id}/activate`, // POST
  passive: (id: string) => `/periodic-generations/${id}/passive`, // POST
  remove: (id: string) => `/periodic-generations/${id}`, // DELETE
} as const

export const PERIODIC_LIST_KEY = ['periodicGenerationList'] as const

/** Liste durum filtresi (Hepsi/Aktif/Pasif). `ALL` filtresizdir. */
export const periodicStatusFilterOptions = {
  ALL: 'Hepsi',
  ACTIVE: 'Aktif',
  PASSIVE: 'Pasif',
} as const

export type TPeriodicStatusFilter = keyof typeof periodicStatusFilterOptions
export const PERIODIC_AVAILABLE_DRAFTS_KEY = [
  'periodicAvailableDrafts',
] as const

export const periodicSuccessMessages = {
  created: 'Periyodik üretim oluşturuldu.',
  updated: 'Periyodik üretim güncellendi.',
  activated: 'Periyodik üretim aktifleştirildi.',
  passivated:
    'Periyodik üretim pasife alındı; devam eden üretim varsa iptal edildi.',
  deleted: 'Periyodik üretim silindi.',
} as const

/** Backend `PeriodicResponseStatusEnum` + `GeneralCrudErrors` kodları. */
export const periodicBackendErrors = {
  GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  PERIODIC_NOT_FOUND: 'Periyodik üretim bulunamadı.',
  PERIODIC_DRAFT_NOT_FOUND: 'Seçilen taslak üretim grubu bulunamadı.',
  PERIODIC_DRAFT_NOT_DRAFT:
    'Yalnızca taslak olarak kaydedilmiş üretim grupları periyotta kullanılabilir.',
  PERIODIC_DRAFT_IN_USE:
    'Bu taslak başka bir periyotta kullanılıyor; önce o periyodu silin veya taslağı değiştirin.',
} as const
